module.exports = __webpack_public_path__ + "static/the-couple-next-door-baf0256db351588f188947003786b1a6.jpg";